// Javascript
import './js/nav';
import './js/advanced-filter';
import './js/skip-link-focus-fix';
import './js/smooth-scroll';
import './js/lazy-youtube';
import './js/region-selector';

// SASS
import './scss/main.scss';

// Fonts
import './fonts/roboto-regular.woff';
import './fonts/roboto-regular.woff2';
import './fonts/Lexend-Regular.woff';
import './fonts/Lexend-Regular.woff2';
import './fonts/Lexend-ExtraBold.woff';
import './fonts/Lexend-ExtraBold.woff2';
import './fonts/Bitter-Bold.woff';
import './fonts/Bitter-Bold.woff2';
